<script>
export default {
	props: ['close', 'reset-type'],
}
</script>

<template>
<div class="flex xmd:hidden justify-between items-center py-m">
    <div @click="$emit('reset-type')" class="button-toback">
        <img src="/img/icons/menu/arrow-right.svg" alt="left-arrow">
    </div>
    <slot></slot>
    <div @click="$emit('close')" class="button">
        <img src="/img/icons/menu/icon-close.svg" alt="cross">
    </div>
</div>
</template>
